// @core/api/endpoints/notifications/delete_channel.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/notifications';

/**
 * Delete notification channel
 * Permanently deletes a notification channel. Ensure no active notifications depend on this channel before deletion.
 */
export async function DeleteChannel(
  channel_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/channels/:channel_id`;
  requestPath = requestPath.replace(':channel_id', encodeURIComponent(channel_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
